export default "__VITE_ASSET__D76T0O$H__"